import InsertChartIcon from '@mui/icons-material/InsertChart';

export default function InfoIcon() {
    return (
        <>
            <svg width={0} height={0}>
                <linearGradient id="gradientColorsInfo" x1={0} y1={1} x2={1} y2={0} gradientTransform="rotate(0)">
                    <stop offset='0%' stopColor="#B9EFFF" />
                    <stop offset='100%' stopColor="#F2F6F8" />
                </linearGradient>
            </svg>
            <InsertChartIcon sx={{ fill: "url(#gradientColorsInfo)", fontSize: "26px", display: "inline-block" }} />
        </>
    )
};